import { moment } from 'omni-common-ui';

export const nextFrom = (aMoment) => {
  const paramMoment = moment.parseZone(aMoment).clone();
  return paramMoment.clone()
      .startOf('day')
      .add(1, 'month')
      .date(4);
};

export default { nextFrom };



// WEBPACK FOOTER //
// ./domain/FinancialClosingMoment/index.js